var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7309_1678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0C3.1826 0 6.23484 1.26428 8.48528 3.51472C10.7357 5.76516 12 8.8174 12 12C8.8174 12 5.76516 10.7357 3.51472 8.48528C1.26428 6.23484 0 3.1826 0 0ZM24 24C20.8174 24 17.7652 22.7357 15.5147 20.4853C13.2643 18.2348 12 15.1826 12 12C15.1826 12 18.2348 13.2643 20.4853 15.5147C22.7357 17.7652 24 20.8174 24 24ZM12 12C12 10.4087 12.6321 8.88258 13.7574 7.75736C14.8826 6.63214 16.4087 6 18 6C18 7.5913 17.3679 9.11742 16.2426 10.2426C15.1174 11.3679 13.5913 12 12 12ZM12 12C12 13.5913 11.3679 15.1174 10.2426 16.2426C9.11742 17.3679 7.5913 18 6 18C6 16.4087 6.63214 14.8826 7.75736 13.7574C8.88258 12.6321 10.4087 12 12 12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7309_1678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMint);
export default __webpack_public_path__ + "static/media/mint.0e64465155fa71f02613be583ac51725.svg";
export { ForwardRef as ReactComponent };